import api from "./api-v0"

export const login = async (credentials) => {
  try {
    const response = await api.post("/auth.routes.php", credentials)
    return response.data
  } catch (error) {
    console.error("Login error:", error)
    throw error
  }
}

export const getUserProfile = async () => {
  try {
    const response = await api.get("/users.routes.php")
    return response.data
  } catch (error) {
    console.error("Get user profile error:", error)
    throw error
  }
}
